import { render, staticRenderFns } from "./CustomerPermissionsModal.vue?vue&type=template&id=a6a141c2&"
import script from "./CustomerPermissionsModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerPermissionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports